import React, { useEffect, useState } from 'react';

import { Pagination } from '@pkg/components/Sections/Admin/Pagination/styles';
import { ButtonIcon } from '@pkg/components/Sections/Profile/Buttons';
import { Sizes } from '@pkg/components/Sections/Profile/Buttons/ButtonIcon/types';

import { type PagingParams } from '@app/client';

interface PaginationProps {
    pagingParams: PagingParams;
    goToPage: (page: number) => void;
}
export const AdminPagination = ({ pagingParams, goToPage }: PaginationProps) => {
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        if (pagingParams?.page) {
            setCurrentPage(pagingParams?.page);
        }
    }, [pagingParams?.page]);

    const nextDisabled = Boolean(
        pagingParams?.total &&
            pagingParams?.limit &&
            currentPage >= Math.floor(pagingParams?.total / pagingParams?.limit),
    );
    const pages =
        pagingParams?.total && pagingParams?.limit && Math.floor(pagingParams?.total / pagingParams?.limit) + 1;

    return (
        <Pagination>
            <ButtonIcon
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 0}
                color={'transparent'}
                size={Sizes.small}
            >
                ⇦
            </ButtonIcon>
            <p>{`Page ${currentPage + 1} of ${pages}`}</p>
            <ButtonIcon
                color={'transparent'}
                size={Sizes.small}
                onClick={() => goToPage(currentPage + 1)}
                disabled={nextDisabled}
            >
                ⇨
            </ButtonIcon>
        </Pagination>
    );
};
